import React from 'react';
import { abbreviateNumber } from 'js-abbreviation-number';
import { Link } from 'react-router-dom';
import {BsFillCheckCircleFill} from 'react-icons/bs';
import VideoLength from '../shared/VideoLength';

const VideoCard = ({video}) => {
  return (
    <Link to={`/video/${video.videoId}`}>
      <div className='flex flex-col mb-8'>
        <div className='relative justify-center object-cover md:rounded-xl'>
          <img src={video?.thumbnails?.[0]?.url} alt="youtube video_img" className='w-[100%] md:rounded-xl' />
          {
            video?.lengthSeconds && (
              <VideoLength time={video?.lengthSeconds} />
            )
          }
        </div>
        <div className='flex mt-3'>
            <img className='h-7 rounded-full' src={video?.author?.avatar[0]?.url} alt="owner img" />
            <div className='text-white ml-2 '>
              <span className='text-sm font-bold line-clamp-2'>{video?.title}</span>
              <span className='flex text-white/[0.6] items-center text-[12px]'>
              {video?.author?.title}
                {
                  video?.author?.badges[0]?.type === "VERIFIED_CHANNEL" && (
                    <BsFillCheckCircleFill className='text-white/[0.5] ml-1 text-[12px] mt-1' />
                  )
                }
              </span>
              <span className='text-sm text-white/[0.6]'>
                {
                  `${abbreviateNumber(video?.stats?.views, 1)} views`
                }
                {` • ${video?.publishedTimeText}`}
              </span>
            </div>
        </div>
      </div>
    </Link>
  )
}

export default VideoCard;
